import React, { useState } from 'react';
import Temple from '../../assets/temple_bg.png';
import Temple2 from '../../assets/temple2.png';
import Indoor1 from '../../assets/indoor1.jpeg';
import Indoor2 from '../../assets/indoor2.jpg';
import Indoor3 from '../../assets/indoor3.jpg';
import sorrounding1 from '../../assets/sorrounding1.jpeg';
import sorrounding2 from '../../assets/sorruonding2.jpg';
import sorrounding3 from '../../assets/sorruonding3.jpg';

const FullGallery = () => {
  const [category, setCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const images = [
    { src: Temple, category: 'Backview' },
    { src: Temple2, category: 'Backview' },
    { src: Temple, category: 'Backview' },
    { src: Indoor1, category: 'Indoor' },
    { src: Indoor2, category: 'Indoor' },
    { src: Indoor3, category: 'Indoor' },
    { src: sorrounding1, category: 'Surrounding' },
    { src: sorrounding2, category: 'Surrounding' },
    { src: sorrounding3, category: 'Surrounding' },
  ];

  // Filter by category
  const filteredImages = images.filter(img => {
    const matchesCategory = category === 'All' || img.category === category;
    const matchesSearch = img.src.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-bl from-[#F3E8D5] to-[#fcc76d] w-full px-2 py-2">
      <div className="relative flex flex-col w-full justify-center items-center max-w-[1440px] h-auto py-10 px-4 sm:px-6 md:px-10 mt-24">

        {/* Search Input */}
        <div className="w-full flex justify-end mb-6">
          <input
            type="text"
            placeholder="Search images..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full sm:w-[20%] px-4 py-3 border border-[#3B250F] rounded-full focus:outline-none focus:ring-1 focus:ring-[#3B250F] text-[#3B250F] placeholder-[#9B7D58]"
          />
        </div>

        {/* Filter Buttons */}
        <div className="w-full flex justify-end mb-6">
          <div className="flex flex-wrap justify-center items-center gap-4">
            {['All', 'Indoor', 'Surrounding', 'Backview'].map((cat) => (
              <button
                key={cat}
                onClick={() => setCategory(cat)}
                className={`rounded-full text-white text-sm font-semibold px-5 py-3 ${
                  category === cat ? 'bg-[#3B250F]' : 'bg-[#f3af38]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 place-items-center">
          {filteredImages.map((img, index) => (
            <div key={index} className="w-full max-w-[400px] h-auto rounded-md overflow-hidden shadow-md">
              <img
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-105"
                src={img.src}
                alt={`image-${index}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FullGallery;
